// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"Bv","carousel__wrapper_on_sides":"Cv","arrows_wrapper":"Ev","arrows_wrapper_right":"Fv","arrows_wrapper_vertical":"Gv","arrows_wrapper_on_sides":"Hv","arrow_button":"Iv","carousel_arrow_left":"Jv","carousel_arrow_left_on_side":"Kv","carousel_arrow_right_on_side":"Lv","carousel_arrow":"Mv","arrows_wrapper_rounded":"Nv","carousel__fullWidth":"Ov"};
    if(module.hot) {
      // 1713361650059
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  